import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const translationsVersion = process.env.REACT_APP_TRANSLATIONS_VERSION || '1';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${translationsVersion}`,
        },
        debug: true,
        lng: 'de',
        fallbackLng: 'de',
        interpolation: {
            escapeValue: false,
        }
    });

export default i18n;